(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var EASE = 'cubic-bezier(0.16, 1, 0.3, 1)';

  function prep(el, type, delay) {
    el.style.willChange = 'opacity, transform';
    el.style.opacity = '0';
    el.style.transition = 'opacity 0.72s ' + EASE + ', transform 0.72s ' + EASE;
    if (delay) el.style.transitionDelay = delay + 'ms';
    if (type === 'up')    { el.style.transform = 'translateY(40px)'; }
    if (type === 'left')  { el.style.transform = 'translateX(-40px)'; }
    if (type === 'right') { el.style.transform = 'translateX(40px)'; }
    if (type === 'scale') { el.style.transform = 'scale(0.93)'; }
  }

  function reveal(el) {
    el.style.opacity = '1';
    el.style.transform = 'none';
    el.style.willChange = 'auto';
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        reveal(entry.target);
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  function watch(el, type, delay) {
    prep(el, type, delay);
    io.observe(el);
  }

  function init() {
    /* ── Hero ── */
    var heroImg = document.querySelector('.bloom-hero__image-col');
    var heroText = document.querySelector('.bloom-hero__text-col');
    if (heroImg)  watch(heroImg,  'left',  0);
    if (heroText) watch(heroText, 'right', 120);

    /* ── Section labels ── */
    document.querySelectorAll('.bloom-label').forEach(function (el) {
      watch(el, 'up', 0);
    });

    /* ── Section headings ── */
    document.querySelectorAll(
      '.bloom-section h2, .bloom-reviews__heading, .bloom-guarantee__heading, .bloom-email__heading'
    ).forEach(function (el) {
      watch(el, 'up', 80);
    });

    /* ── Proof bar brands ── */
    document.querySelectorAll('.bloom-proof-bar__brand').forEach(function (el, i) {
      watch(el, 'up', i * 55);
    });

    /* ── Problem → Solution columns ── */
    var psLeft = document.querySelector('.bloom-ps__problem');
    var psRight = document.querySelector('.bloom-ps__solution');
    if (psLeft)  watch(psLeft,  'left',  0);
    if (psRight) watch(psRight, 'right', 80);

    document.querySelectorAll('.bloom-ps__item').forEach(function (el, i) {
      watch(el, 'up', i * 65);
    });

    /* ── Product cards ── */
    document.querySelectorAll('.bloom-product-card').forEach(function (el, i) {
      watch(el, 'up', i * 90);
    });

    /* ── UGC photos ── */
    document.querySelectorAll('.bloom-ugc__photo').forEach(function (el, i) {
      watch(el, 'scale', i * 55);
    });

    /* ── Benefits ── */
    var benefitImg = document.querySelector('.bloom-benefits__image-col');
    if (benefitImg) watch(benefitImg, 'left', 0);
    document.querySelectorAll('.bloom-benefits__row').forEach(function (el, i) {
      watch(el, 'up', i * 70);
    });

    /* ── Reviews ── */
    var featuredReview = document.querySelector('.bloom-reviews__featured');
    if (featuredReview) watch(featuredReview, 'up', 0);
    document.querySelectorAll('.bloom-review-card').forEach(function (el, i) {
      watch(el, 'up', i * 100);
    });

    /* ── Reels ── */
    document.querySelectorAll('.bloom-reel-item').forEach(function (el, i) {
      watch(el, 'up', i * 80);
    });

    /* ── Comparison rows ── */
    document.querySelectorAll('.bloom-comparison__row').forEach(function (el, i) {
      watch(el, 'up', i * 45);
    });

    /* ── Guarantee ── */
    document.querySelectorAll(
      '.bloom-guarantee__icon, .bloom-guarantee__heading, .bloom-guarantee__body'
    ).forEach(function (el, i) {
      watch(el, 'up', i * 90);
    });

    /* ── Email ── */
    document.querySelectorAll(
      '.bloom-email__heading, .bloom-email__subtext, .bloom-email__form'
    ).forEach(function (el, i) {
      watch(el, 'up', i * 80);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
